<template>
  <CustomTable
    title=""
    :rowsData="this.data.data"
    :columns="columns"
    :stickyHeader="false"
    :loading="isFetching"
    :custom-body="true"
    :small="true"
    :hideTopTitle="true"
    :marginTop="20"
  >
    <template #customBody="props">
      <q-tr>
        <custom-table-cell align="left" vertical-align="center">
          <b>{{ props.row.assign_type_name }}</b>
        </custom-table-cell>
        <custom-table-cell align="left" vertical-align="center">
          {{ props.row.employee_fio }}
        </custom-table-cell>
        <custom-table-cell align="left" vertical-align="center">
          {{ this.formatPhoneNumber(props.row.phone) }}
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          {{ props.row.sign_date }}
        </custom-table-cell>
        <custom-table-cell align="center" vertical-align="center">
          <CheckOrClose :value="props.row.is_signed" />
        </custom-table-cell>
      </q-tr>
    </template>
  </CustomTable>
</template>

<script>
import CheckOrClose from "@/components/common/CheckOrClose";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell.vue";
import {signersColumns} from "@/views/ResidentialSettings/services";
import { formatPhoneNumber } from "@/services";
export default {
  name: "project-document-signers",
  props: ['data'],
  components: {
    CheckOrClose,
    CustomTable,
    CustomTableCell,
  },
  methods: {
    formatPhoneNumber
  },
  data() {
    return {
      columns: signersColumns,
    };
  },
}
</script>

<style scoped lang="scss">
.text {
  max-width: 570px;
  min-width: 550px;

  @media (max-width: 576px) {
    max-width: 100%;
  }
}
</style>
